export { M10Hero } from './M10Hero';
export { M10Hero as default } from './M10Hero';
